module.exports = __webpack_public_path__ + "img/suggestsTitle.9502bc45.svg";